import axios from 'axios';
import {
    TeamCalendarEvent,
    TeamCalendarEventSearchRequest,
    TeamCalendarEventUpsertRequest,
    TeamCalendarPublicCalendarResponse,
    TeamCalendarShareLink,
    TeamCalendarShareLinkCreateRequest
} from 'data/schemas/TeamCalendar';

export async function retrieveTeamCalendarEvents(params?: TeamCalendarEventSearchRequest) {
    return axios.get<TeamCalendarEvent[]>('v1/team-calendar/events', { params });
}

export async function retrieveTeamCalendarEventById(id: string) {
    return axios.get<TeamCalendarEvent>(`v1/team-calendar/events/${id}`);
}

export async function callCreateTeamCalendarEvent(body: TeamCalendarEventUpsertRequest) {
    return axios.post<TeamCalendarEvent>('v1/team-calendar/events', body);
}

export async function callUpdateTeamCalendarEvent(id: string, body: TeamCalendarEventUpsertRequest) {
    return axios.put<TeamCalendarEvent>(`v1/team-calendar/events/${id}`, body);
}

export async function callDeleteTeamCalendarEvent(id: string, updatedBy: string) {
    return axios.delete<string>(`v1/team-calendar/events/${id}`, {
        params: { updatedBy }
    });
}

export async function retrieveTeamCalendarShareLinks() {
    return axios.get<TeamCalendarShareLink[]>('v1/team-calendar/share-links');
}

export async function callCreateTeamCalendarShareLink(body: TeamCalendarShareLinkCreateRequest) {
    return axios.post<TeamCalendarShareLink>('v1/team-calendar/share-links', body);
}

export async function callDeleteTeamCalendarShareLink(id: string, updatedBy: string) {
    return axios.delete<string>(`v1/team-calendar/share-links/${id}`, {
        params: { updatedBy }
    });
}

export async function retrievePublicTeamCalendar(
    shareToken: string,
    params?: TeamCalendarEventSearchRequest
) {
    return axios.get<TeamCalendarPublicCalendarResponse>(`v1/team-calendar/public/${shareToken}`, {
        params
    });
}
